import React from 'react';

/**
 * DockStatusFilter Component
 * Minimal filter toolbar for DockStatus page matching ReservationManagement style
 */
const DockStatusFilter = ({
    filterFactory,
    setFilterFactory,
    filterType,
    setFilterType,
    filterDock,
    setFilterDock,
    factories = [],
    doorGroups = [],
    docks = []
}) => {
    return (
        <div
            className="header-grid"
            style={{
                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                gap: '1rem'
            }}
        >
            {/* Factory Filter */}
            <div className="header-item">
                <label className="header-label">FABRİKA</label>
                <select
                    className="glass-input"
                    value={filterFactory}
                    onChange={e => {
                        setFilterFactory(e.target.value);
                        setFilterType('all');
                        setFilterDock('all');
                    }}
                >
                    <option value="all">Tüm Fabrikalar</option>
                    {factories.map(f => (
                        <option key={f.id} value={f.id}>{f.name}</option>
                    ))}
                </select>
            </div>

            {/* Door Group Filter */}
            <div className="header-item">
                <label className="header-label">RAMPA GRUBU</label>
                <select
                    className="glass-input"
                    value={filterType}
                    onChange={e => {
                        setFilterType(e.target.value);
                        setFilterDock('all');
                    }}
                >
                    <option value="all">Tümü</option>
                    {doorGroups.map(bg => (
                        <option key={bg.id} value={bg.id}>{bg.name}</option>
                    ))}
                </select>
            </div>

            {/* Dock Filter */}
            <div className="header-item">
                <label className="header-label">RAMPA</label>
                <select
                    className="glass-input"
                    value={filterDock}
                    onChange={e => setFilterDock(e.target.value)}
                >
                    <option value="all">Tümü</option>
                    {docks
                        .filter(d => {
                            if (filterFactory !== 'all' && d.factoryId !== filterFactory) return false;
                            if (filterType !== 'all' && d.doorGroupId !== filterType) return false;
                            return true;
                        })
                        .map(d => (
                            <option key={d.id} value={d.id}>{d.name}</option>
                        ))
                    }
                </select>
            </div>


        </div>
    );
};

export default DockStatusFilter;
